export const PUBLIC_DATA_SUBSCRIBED = 'SERVER/PUBLIC_DATA_SUBSCRIBED';
export const PUBLIC_DATA_RECEIVED = 'SERVER/PUBLIC_DATA_RECEIVED';
